import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import theme from '../../../theme'
// material ui components
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material';



/**
 * component for use in menu component
 * @param classes
 * @param icon
 * @param label
 * @param active
 * @param handleClick
 * @param drawerOpen
 * @returns {*}
 * @constructor
 */
const MenuItem = ({ classes, icon, label, active, handleClick, drawerOpen }) => {
    const styles = {
        active: {
            backgroundColor: theme.palette.custom.activeItem,
            padding:0,
            paddingTop:10,
            paddingLeft:drawerOpen?20:0,
            width:'100%',
            paddingBottom:10,
            justifyContent:"center",
            transition:'width ease-in 3s',
            [theme.breakpoints.down('xs')]: {
                padding: 0
    
            },
            [theme.breakpoints.down('sm')]: {
                padding: 0
            },
        },
        inactive: {
            //none
            padding:0,
            paddingTop:10,
            paddingBottom:10,
            paddingLeft:drawerOpen?20:0,
            justifyContent:"center",
            width:'100%',
            transition:'width ease-in 3s',
            [theme.breakpoints.down('xs')]: {
                padding: 0,
            },
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
            },
        },
        elementColor: {
            color: '#fff',
            padding:0,
            margin:0
        }, 
        icon: {
            color: '#fff',
            dislay:'flex',
            fontSize: 24, 
            //padding: 0,
            alignItem:'left',
        },
        listItem: {
            '&:hover': {
                backgroundColor: theme.palette.custom.hoverItem,
            },
        },
    }


    return(<ListItem style={active?styles.active:styles.inactive} sx={{height:50, display:"flex", flexDirection:"row", alignItems:"left", justifyContent:"left",}}
        >
        <Box sx={{...styles.icon, paddingTop:1}}>
            {icon}
        </Box>
        {drawerOpen&& 
        <ListItemText style={{paddingLeft:30, paddingTop:2}}>
            <Typography style={styles.elementColor}>{label}</Typography>
        </ListItemText>}
        </ListItem>)
}

MenuItem.defaultProps = {
    active: false,
}

MenuItem.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
}


export default MenuItem
